import React, { useEffect, useRef } from "react";
import { Outlet } from "react-router-dom";
import { PeekAlert, PeekBox, PeekGrid, PeekScreenLoader, PeekSnackbar, PeekTypography, } from "@piiqtechnologies/ui-components";
import { RefetchProvider, useError, useLoader, useNotification } from "@piiqtechnologies/ui-lib";
import { AnalyticsArea, useTrackEvent } from "@hooks";
export const AppLayout = ({}) => {
    const { loader } = useLoader();
    const { error, setError } = useError();
    const { notification, setNotification } = useNotification();
    const track = useTrackEvent();
    // Central chokepoint for user-visible errors. Fires once per distinct error message as it
    // appears in the snackbar. Endpoint/status/code aren't available at this layer — capturing
    // those precisely would need an axios interceptor in ui-lib (follow-up).
    const prevErrorRef = useRef(null);
    useEffect(() => {
        if (error && error !== prevErrorRef.current) {
            track(AnalyticsArea.Error, "API Request Failed", { message: error });
        }
        prevErrorRef.current = error !== null && error !== void 0 ? error : null;
    }, [error, track]);
    const handleCloseAlert = (_event, reason) => {
        if (reason === "clickaway")
            return;
        setError(null);
        setNotification(null);
    };
    return (React.createElement(PeekBox, { sx: { backgroundColor: "grey.50", overflowY: "auto", display: "flex", flexDirection: "column" }, height: "100vh" },
        loader && React.createElement(PeekScreenLoader, { layered: true }),
        React.createElement(PeekGrid, { container: true, sx: { flex: 1 }, width: "100vw", maxWidth: "100vw !important", overflow: "auto", alignItems: "flex-start", height: "-webkit-fill-available" },
            React.createElement(RefetchProvider, null,
                React.createElement(Outlet, null))),
        React.createElement(PeekSnackbar, { anchorOrigin: { vertical: "top", horizontal: "right" }, open: !!error || !!notification, autoHideDuration: 3000, "data-testid": "app-error", onClose: handleCloseAlert },
            React.createElement(PeekBox, null,
                React.createElement(PeekAlert, { sx: { alignItems: "center" }, onClose: handleCloseAlert, severity: (error && "error") || "success" },
                    React.createElement(PeekTypography, { variant: "body1" }, error || notification))))));
};
export default AppLayout;
